var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isColspan)?_c('td',{attrs:{"colspan":_vm.field.colspanNum}},[_c('span',{staticClass:"total"},[_vm._v(_vm._s(_vm.colspanSumTotal(_vm.field)))])]):_c('td',[_c('span',{staticClass:"total"},[_vm._v(_vm._s(_vm.colSum(_vm.field.key)))])])}
var staticRenderFns = []

export { render, staticRenderFns }